import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { GlobalErrorHandlerService } from '../../../core/services/global-error-handler.service';

@Component({
  selector: 'app-unexpected-error-modal',
  standalone: true,
  templateUrl: './unexpected-error-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnexpectedErrorModalComponent {
  protected readonly errorHandler = inject(GlobalErrorHandlerService);

  reload(): void { globalThis.location.reload(); }
}
